// ./src/contexts/AccommodationsContext/AccommodationsContext.tsx
//
// Thin context wrapper around the useAccommodations hook. All derived data lives in
// the hook itself. See PointsOfInterestContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  useAccommodations,
  UseAccommodationsOptions,
  UseAccommodationsReturn,
} from "@/hooks/useAccommodations";

const AccommodationsContext = createContext<UseAccommodationsReturn | null>(null);

export interface AccommodationsProviderProps extends UseAccommodationsOptions {
  children: React.ReactNode;
}

export const AccommodationsProvider: React.FC<AccommodationsProviderProps> = ({ children, ...options }) => {
  const value = useAccommodations(options);

  return <AccommodationsContext.Provider value={value}>{children}</AccommodationsContext.Provider>;
};

export const useAccommodationsContext = (): UseAccommodationsReturn => {
  const context = useContext(AccommodationsContext);

  if (!context) {
    throw new Error(
      "useAccommodationsContext must be used within an <AccommodationsProvider>. " +
        "Wrap your component tree with <AccommodationsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalAccommodationsContext = (): UseAccommodationsReturn | null => {
  return useContext(AccommodationsContext);
};
